import { createContext, useState, useContext, useEffect } from "react";
import Cookie from "js-cookie";
import axios from "axios";
import { toast } from "sonner";
import { BaseUrlApi, ErrorMessage } from "../lib/api";
import { useAuth } from "./AuthContext";

const APIContext = createContext();

export const useAPI = () => {
  return useContext(APIContext);
};

export const APIProvider = ({ children }) => {
  const { token } = useAuth();
  
  // -------------CheckAttendance-------------
  const [loadingCheckAttendance, setLoadingCheckAttendance] = useState(false);
  const [checkAttendance, setCheckAttendance] = useState([]);

  const getCheckAttendance = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/check-attendance`);
      setCheckAttendance(data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingCheckAttendance(false);
    }
  };

  const CheckAttendanceItems = {
    checkAttendance,
    loadingCheckAttendance,
    getCheckAttendance,
  };

  useEffect(() => {
    if (token) {
      setLoadingCheckAttendance(true);
      getCheckAttendance();
    }
  }, [token]);

  return (
    <APIContext.Provider
      value={{
        CheckAttendanceItems,
      }}
    >
      {children}
    </APIContext.Provider>
  );
};
